import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import * as Sentry from '@sentry/angular-ivy';

import packageInfo from '../package.json';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// see: https://docs.sentry.io/platforms/javascript/guides/angular
if (environment.sentryDsn) {
  Sentry.init({
    dsn: environment.sentryDsn,
    integrations: [],
    release: `${packageInfo.version} (${packageInfo.ch_pixelverse.gitHash})`,
    environment: environment.name
  });
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

/* FOR DEBUGGING ONLY: replace getUserMedia with a proxy that logs arguments and results
const realGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
navigator.mediaDevices.getUserMedia = function (constraints) {
  if (constraints !== undefined) {
    console.log(`> getUserMedia: constraints= ${JSON.stringify(constraints)}`);
  }
  return realGetUserMedia(constraints).then(function (mediaStream) {
    if (mediaStream.getVideoTracks().length > 0) {
      const videoTrack = mediaStream.getVideoTracks()[0];
      const settings = videoTrack.getSettings();
      console.log(`< getUserMedia OK: video track has size ${settings.width} x ${settings.height}`);

      // hook applyConstraints on the video track
      const realApplyConstraints = videoTrack.applyConstraints;
      videoTrack.applyConstraints = function (constraints) {
        console.log(`> videoTrack.applyConstraints():`);
        if (constraints) {
          console.log(JSON.stringify(constraints));
        }

        const wrapped = realApplyConstraints.bind(videoTrack);
        return wrapped(constraints).then(() => {
          console.log(`< videoTrack.applyConstraints(): OK`);
          const settings = videoTrack.getSettings();
          console.log(`Video track now has resolution: ${settings.width} x ${settings.height}`);
        });
      }
      console.log(`applyConstraints hook installed`);
    }
    return mediaStream;
  });
}
console.log(`gUM hook installed`);
*/
